module.exports = __webpack_public_path__ + "img/producto_msh.53b9de2f.jpg";